import { render, staticRenderFns } from "./LargeCircleIcon.vue?vue&type=template&id=05594f00&scoped=true"
import script from "./LargeCircleIcon.vue?vue&type=script&lang=js"
export * from "./LargeCircleIcon.vue?vue&type=script&lang=js"
import style0 from "./LargeCircleIcon.vue?vue&type=style&index=0&id=05594f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05594f00",
  null
  
)

export default component.exports